import { axiosInstance, axiosInstanceV2 } from '../axios.ts';
import { IUser, IUserRegistrationData } from '../types';
import { cleanCPFCNPJ, snakeCaseDictToCamelCaseDict } from '../utils.ts';

export interface GetTokenResponse {
  token: string;
  user: IUser;
}

export async function getToken(
  username: string,
  password: string,
  agreement_id: number | string | null = null
): Promise<GetTokenResponse> {
  return axiosInstance
    .post('/users/tokens/' + ((agreement_id && '?agreement_id=' + agreement_id) || ''), {
      username,
      password,
      agreement_id,
    })
    .then(({ data }) => ({
      token: data.token,
      user: snakeCaseDictToCamelCaseDict(data.user) as IUser,
    }));
}

export function registerUser(user: IUserRegistrationData, agreementId: number): Promise<IUser & { token: string }> {
  return axiosInstance
    .post(`/profile/?agreement_id=${agreementId}`, { ...user, cpf: cleanCPFCNPJ(user.cpf) })
    .then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IUser & { token: string });
}

export async function validateCNPJCPF(cnpjCpf: string, agreementId: number) {
  return axiosInstanceV2
    .post(`/agreement/vinculate/?agreement_id=${agreementId}`, {
      cpf: cleanCPFCNPJ(cnpjCpf),
    })
    .then(({ data }) => data);
}

export function validatePromocode(code: string) {
  return axiosInstance.post('/validate_promocode/', { promocode: code });
}
